import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
const UploadPapidsRequest = (data = {}): Promise<AxiosResponse<any>> => Request.post(`/advisors/employer/upload-papdis`, data);

export default UploadPapidsRequest;
